import React from "react";
import "./list-of-custom-values.scss";
import {Numeric} from "./numeric";
import {NonNumeric} from "./non-numeric";

export const ListOfCustomValues = ({step, form, colMapDataType}) => {
    return ["Double", "Int"].includes(colMapDataType) ? Numeric({step, form}) : NonNumeric({step, form});
};
